import {
    FC,
    FormEvent,
    ReactElement,
    useRef,
    useState,
} from 'react'

import { FormActionButtons } from '../../../compositions'
import trans from '../../../helpers/trans'
import { ModalFormProps } from '../../../types/modalFormTypes'

import './DeleteChangeLogEntryForm.scss'

interface DeleteChangeLogEntryFormProps extends ModalFormProps<{ id: string }> {
    changeLogEntryId: string
}

export const DeleteChangeLogEntryForm: FC<DeleteChangeLogEntryFormProps> = ({
    isLoading,
    changeLogEntryId,
    onSubmit,
    onCancel,
}): ReactElement => {
    const [formData, setFormData] = useState({ id: changeLogEntryId })

    const formRef = useRef<HTMLFormElement>(null)

    const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
        e.preventDefault()

        const formDataToSubmit = { id: formData.id }
        setFormData(formDataToSubmit)

        onSubmit(formDataToSubmit)
    }

    return (
        <form ref={formRef} onSubmit={handleSubmit} className="delete-change-log-entry-form">
            <div className="delete-change-log-entry-form__row">
                <div className="delete-change-log-entry-form__col">
                    <p>{trans('containers.forms.deleteChangeLogEntryForm.deleteChangeLogEntry')}</p>
                </div>
            </div>
            <FormActionButtons
                isLoading={isLoading}
                submitText={trans('common.delete')}
                onCancelClick={onCancel}
            />
        </form>
    )
}
